window.onload = function () {
  
}
// DOMContentLoaded
window.addEventListener("load", function () {
  let burying_boxs = document.querySelectorAll(".index-section .burying_box")
  if (document.querySelectorAll(".index-section .burying_box .article__grid-image").length > 0) {
    document.querySelectorAll(".index-section .burying_box .article__grid-image")[0].addEventListener("click", function (eve) {
      // let data_burying = ele.getAttribute("data-burying") || ""
      
      eve.stopPropagation()
      eve.preventDefault()
      gtag('event', "footer_1");
    })
    document.querySelectorAll(".index-section .burying_box .article__grid-image")[1].addEventListener("click", function (eve) {
      // let data_burying = ele.getAttribute("data-burying") || ""
      // 
      
      eve.stopPropagation()
      eve.preventDefault()
      gtag('event', "footer_2");
    })
  }

  if (document.querySelectorAll(".index-section .buring_btn").length > 0) {
    document.querySelectorAll(".index-section .buring_btn")[0].addEventListener("click", function (eve) {
      // let data_burying = ele.getAttribute("data-burying") || ""
      // 
      eve.stopPropagation()
      eve.preventDefault()
      
      gtag('event', "footer_1");
    })
    document.querySelectorAll(".index-section .buring_btn")[1].addEventListener("click", function (eve) {
      // let data_burying = ele.getAttribute("data-burying") || ""
      // 
      eve.stopPropagation()
      eve.preventDefault()
      
      gtag('event', "footer_2");
    })
  }

})
